export default [
  {
    path: '/fans/fansDetail/:type',
    name: 'fansDetail',
    component: () => import(/* webpackChunkName: "fansDetail" */ '../../views/fans/FansDetail.vue'),
    meta: {
      title: '', // 粉丝圈详情
    },
  },
  {
    path: '/fans/contentDetail',
    name: 'contentDetail',
    component: () => import(/* webpackChunkName: "contentDetail" */ '../../views/fans/contentDetail/ContentDetail.vue'),
    meta: {
      title: '帖子详情',
    },
  },
  {
    path: '/fans/subComments',
    name: 'subComments',
    component: () => import(/* webpackChunkName: "subComments" */ '../../views/fans/SubComments.vue'),
    meta: {
      title: '评论详情',
    },
  },
]
